import React from 'react';
import { ShieldCheck, UserRoundCheck, Workflow } from 'lucide-react';
import '../trust-homepage.css';

const WORK_PRINCIPLES = [
  {
    icon: Workflow,
    title: 'Primero entendemos qué necesita el cliente',
    description: 'Revisamos qué pregunta, qué información hace falta y qué debería ocurrir después.',
  },
  {
    icon: ShieldCheck,
    title: 'Acordamos qué puede hacer Áncora',
    description: 'Dejamos claros los sistemas, permisos, pruebas y límites antes de empezar.',
  },
  {
    icon: UserRoundCheck,
    title: 'El equipo mantiene el control',
    description: 'Las excepciones y decisiones sensibles siguen en manos de una persona.',
  },
] as const;

export const WhoWeAreSection: React.FC = () => (
  <section className="trust-section trust-team" aria-labelledby="who-we-are-title">
    <div className="marketing-grid trust-team__layout">
      <div className="trust-team__intro">
        <h1 id="who-we-are-title">Quiénes somos</h1>
        <p>
          Áncora nació en Madrid como una pequeña empresa con raíces en el mundo tecnológico. Hoy
          ayudamos a otros negocios a atender a sus clientes y continuar el trabajo que nace de cada
          conversación. Conectamos las herramientas que ya utilizan para acompañar todo el recorrido,
          desde el primer contacto hasta el seguimiento y la revisión final, manteniendo siempre a las
          personas al mando.
        </p>
      </div>
      <div className="trust-team__principles">
        {WORK_PRINCIPLES.map(({ icon: Icon, title, description }) => (
          <article key={title}>
            <Icon aria-hidden="true" size={21} />
            <div><h2>{title}</h2><p>{description}</p></div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
